// @ts-nocheck
import { Plugin } from '/home/data/jenkins/workspace/test-front-build/pxx-h5/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','getInitialState','initialStateConfig','request',],
});

export { plugin };
